import { useMemo } from 'react';
import ActionsCellRenderer from '../ActionsCellRenderer';

export const PushApiReportActionsCellRenderer = ({ data, ...rest }) => {
    const buttonConfigs = useMemo(
        () => [
            {
                onClick: () => {},
                iconLabel: 'edit-o',
                dataMetricComponent: 'EditActionButton',
            },
            {
                onClick: () => {},
                iconLabel: 'delete',
                dataMetricComponent: 'DeleteActionButton',
            },
        ],
        []
    );

    return <ActionsCellRenderer data={data} buttonConfigs={buttonConfigs} {...rest} />;
};
